export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: (theme) => theme.spacing(1),
    width: '100%',
    padding: (theme) => theme.spacing(0.75, 2),
    position: 'sticky',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1100,
    margin: '0 auto',
    backgroundColor: 'gray.8',
  },
  icon: {
    fontSize: '20px',
    color: 'warning.main',
  },
  text: {
    fontSize: '14px',
    fontWeight: 500,
    margin: 0,
    color: '#000000',
    textAlign: 'center',
  },
}
